export default "__VITE_ASSET__CZAPhXec__"